import React from 'react';

import styles from '../../testOverview.scss';
import { t } from '../../../../services/i18nService';
import { getA11yAttributesV2 } from '../../../../services/a11yIIBScreenReaderService';
import liveSessioner from '../../../../services/livesession/LiveSessioner';

const GrantHardwareAccessButton = () => {
    const handleGrantHardwareAccess = () => {
        liveSessioner.requestHardwareAccess();
    };

    return (
        <button
            id="grant-hardware-access-button"
            className={`${styles.button} btn`}
            onClick={handleGrantHardwareAccess}
            {...getA11yAttributesV2({
                'aria-label': t('hardwareAccessCheck.grantAccessAreaLabel'),
            })}
        >
            <i className="fa fa-arrow-right" aria-hidden />
            {t('hardwareAccessCheck.grantAccess')}
        </button>
    );
};

export default GrantHardwareAccessButton;
